"use strict"
import f from "./frames.json"
import m from "./mods.json"
import s from "./systems.json"
import w from "./weapons.json"

const data = {
  frames: f,
  mods: m,
  systems: s,
  weapons: w,
}

export default data;